import { useState } from "react";
import {
  getLanguageFromQueryParams,
  shouldRunGeoCheck,
  applyLanguageToUrl,
  isFromIsrael,
  LANGUAGES,
} from "languages";

const resolveInitialLanguage = () => {
  const languageFromParams = getLanguageFromQueryParams();

  if (!shouldRunGeoCheck()) return languageFromParams;

  if (isFromIsrael()) {
    applyLanguageToUrl(LANGUAGES.HE);
    return LANGUAGES.HE;
  }

  return languageFromParams;
};

export const useResolveSignupLanguage = () => {
  const [language] = useState(resolveInitialLanguage);

  return { language };
};

export default useResolveSignupLanguage;
